<template>
  <sTooltip
    v-if="nationalTenderBudjet && currencyRate && currencyRate !== 1">
    <div
      class="h8-text secondary__green_not_active--text text-start"
      data-qa="currency-conversion-tooltip-btn">
      {{ $n(nationalTenderBudjet, 'decimal') }} {{ $t('Tenders.hrn') }}
    </div>
    <div
      slot="content"
      style="max-width: 200px">
      <div
        class="h8-text"
        data-qa="currency-conversion-tooltip-content-1">
        {{ $t('Common.AccordingExchangeRate') }}
      </div>
      <sDivider class="my-1"/>
      <div
        class="h8-text secondary__green_not_active--text"
        data-qa="currency-conversion-tooltip-content-2">
        {{ $t('Common.ExchangeRateOf',{ date: formed_date, exchange_rate: currencyRate, currency}) }}
      </div>
    </div>
  </sTooltip>
</template>

<script>
import { modalMixin } from 'mixins'

export default {
  name: 'currencyConversionTooltip',
  mixins: [ modalMixin ],
  props: {
    // Нужно бы дописать получение с бека и убрать это свойство
    currency: { // название валюты, например "грн." или "$"
      type: String,
      required: true
    },
    currentId: { // код валюты, например 980 для гривны
      type: Number,
      required: true
    },
    price: [String, Number],
    nbuCurrency: Object,
    transform: { //Если false, то price уже посчитанно по курсу НБУ, иначе price - это цена в валюте, которую нужно пересчитать в гривны
      type: Boolean,
      default: true,
    },
  },
  computed: {
    nationalTenderBudjet() {
      if (this.price) {
        return this.transform ? this.price * this.currencyRate : this.price
      } else {
        return this.nbuCurrency?.nationalTenderBudjet
      }
    },
    currencyRate() {
      return this.currentNbuCurrencyRate?.currencyRate ?? this.nbuCurrency?.currencyRate ?? 0
    },
    formed_date() {
      return this.currentNbuCurrencyRate?.currencyRateDate
    },
    currentNbuCurrencyRate() {
      return this.currentId
        ? (this.$store.getters.getNbuCurrencyRateByCurrencyId(this.currentId) || null)
        : null
    },
  },
  watch: {
    currentId: {
      immediate: true,
      handler() {
        this.$store.dispatch('setNbuCurrencyRate', this.currentId)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .tooltip {
    width:223px ;
  }
</style>
